import { render } from "./VPAAMentoring&Commitment.vue?vue&type=template&id=4e7c2496"
import script from "./VPAAMentoring&Commitment.vue?vue&type=script&lang=js"
export * from "./VPAAMentoring&Commitment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__